export default class BottomNav {
  constructor(makeMobxStore) {
    this.reset = makeMobxStore(this);
  }
  set = {
    index: (index = -1) => {
      this.index = index;
    },
    actions: (actions = []) => {
      this.actions = actions;
    },
    Actions: Actions => {
      this.Actions = Actions;
    }
  };
  get loaded() {
    return this.actions.length !== 0 || this.Actions !== undefined;
  }
}
